// @ts-nocheck

import { useEffect } from 'react';

import * as S from './styled';

import { getDashboardBreakdownIds, resolveTheme } from '../../../constants';
import { calcDefaultCusto } from './calcDefaultCusto';

const CDN_SCRIPTS = [
  'https://cdn.jsdelivr.net/npm/chart.js',
  'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
  'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js',
];

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (existing.dataset.loaded === 'true') {
        resolve();
      } else {
        existing.addEventListener('load', () => resolve());
        existing.addEventListener('error', reject);
      }
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.dataset.loaded = 'false';
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true';
      resolve();
    });
    script.addEventListener('error', reject);
    document.body.appendChild(script);
  });
}

const MaintenanceList = () => {
  useEffect(() => {
    let cancelled = false;

    async function boot() {
      try {
        // Load in order (autotable depends on jspdf already being available).
        // eslint-disable-next-line no-restricted-syntax
        for (const src of CDN_SCRIPTS) {
          // eslint-disable-next-line no-await-in-loop
          await loadScript(src);
        }
      } catch (error) {
        console.error('Failed to load maintenance dashboard libraries:', error);
        return;
      }
      if (cancelled) return;
      initDashboard();
    }

    function initDashboard() {
      const Chart = window.Chart;
      // TEMP: revertido pra acesso direto ao Airtable (proxy /airtable/ no ar sem
      // AIRTABLE_TOKEN funcional em produção — 401 em tudo). REACT_APP_AIRTABLE_TOKEN
      // (patNDBvrJyzhZfUR4...) e o token do DRE (patbcu8vQYsta8Ule...) também não
      // têm permissão nessa base — nenhum dos dois é bug daqui. Usando o token do
      // próprio protótipo de Manutenções (DASHBO~3.HTM), confirmado funcionando.
      // Reverter de volta pro proxy assim que AIRTABLE_TOKEN de runtime estiver
      // confirmado funcionando.
      const AIRTABLE_TOKEN =
        'patadYHzYaANGP8cH.083bd2a7ee144b05dc5047ae764923871fd344fad8b211e3d3e9cb1a48cc943d';
      const AIRTABLE_BASE = 'https://api.airtable.com';
      const BASE_ID = 'appOiNEi8xHG9uZly';
      const TABLE_MAINTENANCES = 'Manutenções';
      const TABLE_TICKETS = 'Chamados';
      const TABLE_STATIONS = 'Estações';
      const TABLE_PARTNERS = 'Parceiros';

      const CLOUDINARY_CLOUD_NAME = 'de5fkrvby';
      const CLOUDINARY_UPLOAD_PRESET = 'move_manutencoes';

      let maintenances = [];
      let tickets = [];
      let stations = [];
      let partners = [];
      let stationsMap = {};
      let stationsFullMap = {};
      let partnersMap = {};
      let ticketsMap = {};
      let maintenancesMap = {};
      let timelineChart;
      let typeChart;
      let rankingChart;

      const stationFilter = document.getElementById('stationFilter');
      const typeFilter = document.getElementById('typeFilter');
      const statusFilter = document.getElementById('statusFilter');
      const contratoFilter = document.getElementById('contratoFilter');
      const dateFromFilter = document.getElementById('dateFromFilter');
      const dateToFilter = document.getElementById('dateToFilter');
      const searchInput = document.getElementById('searchInput');
      const ticketModal = document.getElementById('ticketModal');
      const ticketForm = document.getElementById('ticketForm');
      const ticketMessage = document.getElementById('ticketMessage');
      const saveTicketBtn = document.getElementById('saveTicketBtn');

      const maintenanceModal = document.getElementById('maintenanceModal');
      const maintenanceForm = document.getElementById('maintenanceForm');
      const maintenanceMessage = document.getElementById('maintenanceMessage');
      const saveMaintenanceBtn = document.getElementById('saveMaintenanceBtn');

      const recordsModal = document.getElementById('recordsModal');
      const recordsModalTitle = document.getElementById('recordsModalTitle');
      const recordsModalSubtitle = document.getElementById(
        'recordsModalSubtitle',
      );
      const recordsSearch = document.getElementById('recordsSearch');
      const recordsStationFilter = document.getElementById(
        'recordsStationFilter',
      );
      const recordsStatusFilter = document.getElementById(
        'recordsStatusFilter',
      );
      const recordsSeverityFilter = document.getElementById(
        'recordsSeverityFilter',
      );
      const recordsContratoFilter = document.getElementById(
        'recordsContratoFilter',
      );
      const recordsDateFromFilter = document.getElementById(
        'recordsDateFromFilter',
      );
      const recordsDateToFilter = document.getElementById(
        'recordsDateToFilter',
      );
      const recordsTableHead = document.getElementById('recordsTableHead');
      const recordsTableBody = document.getElementById('recordsTableBody');
      let recordsMode = 'tickets';

      const partnersModal = document.getElementById('partnersModal');
      const partnersSearch = document.getElementById('partnersSearch');
      const partnersTableBody = document.getElementById('partnersTableBody');
      const partnerForm = document.getElementById('partnerForm');
      const partnerMessage = document.getElementById('partnerMessage');
      const savePartnerBtn = document.getElementById('savePartnerBtn');

      function field(fields, names, fallback = '') {
        for (const name of names) {
          if (
            fields[name] !== undefined &&
            fields[name] !== null &&
            fields[name] !== ''
          )
            return fields[name];
        }
        return fallback;
      }

      function normalizeText(value, lookupMap = {}) {
        if (Array.isArray(value))
          return value.map((item) => lookupMap[item] || item).join(', ');
        return lookupMap[value] || value || '';
      }

      function normalizeStatus(value) {
        return value || 'Aberto';
      }
      function isOpenStatus(status) {
        return !['Resolvido', 'Cancelado'].includes(normalizeStatus(status));
      }

      function parseDate(value) {
        if (!value) return null;
        if (/^\d{4}-\d{2}-\d{2}/.test(value)) return new Date(value);
        const parts = String(value).split('/');
        if (parts.length === 3) {
          const [day, month, year] = parts;
          return new Date(
            `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`,
          );
        }
        return new Date(value);
      }

      function formatDate(value) {
        const date = parseDate(value);
        if (!date || Number.isNaN(date.getTime())) return value || '-';
        return date.toLocaleDateString('pt-BR');
      }

      async function fetchAirtable(tableName) {
        let records = [];
        let offset = null;
        do {
          const url = new URL(
            `${AIRTABLE_BASE}/v0/${BASE_ID}/${encodeURIComponent(
              tableName,
            )}`,
            window.location.origin,
          );
          if (offset) url.searchParams.set('offset', offset);
          const response = await fetch(url, {
            headers: { Authorization: `Bearer ${AIRTABLE_TOKEN}` },
          });
          const data = await response.json();
          if (!response.ok) {
            console.error('Erro Airtable:', tableName, data);
            throw new Error(
              data.error?.message || `Erro ao buscar tabela ${tableName}`,
            );
          }
          records = records.concat(data.records || []);
          offset = data.offset;
        } while (offset);
        return records;
      }

      async function uploadFilesToCloudinary(fileInputId) {
        const input = document.getElementById(fileInputId);
        const files = input ? Array.from(input.files || []) : [];

        if (!files.length) return [];

        const uploads = [];

        for (const file of files) {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

          const response = await fetch(
            `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/auto/upload`,
            {
              method: 'POST',
              body: formData,
            },
          );

          const data = await response.json();

          if (!response.ok) {
            console.error('Erro Cloudinary:', data);
            throw new Error(
              data.error?.message ||
                'Erro ao enviar arquivo para o Cloudinary.',
            );
          }

          uploads.push({
            url: data.secure_url,
            filename: file.name,
          });
        }

        return uploads;
      }

      async function createAirtableRecord(tableName, fields) {
        const response = await fetch(
          `${AIRTABLE_BASE}/v0/${BASE_ID}/${encodeURIComponent(tableName)}`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${AIRTABLE_TOKEN}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ fields }),
          },
        );
        const data = await response.json();
        if (!response.ok) {
          console.error('Erro ao criar registro:', data);
          throw new Error(
            data.error?.message || 'Erro ao criar registro no Airtable.',
          );
        }
        return data;
      }

      async function loadAirtableData() {
        try {
          const [maintenancesRecords, ticketsRecords, stationsRecords] =
            await Promise.all([
              fetchAirtable(TABLE_MAINTENANCES),
              fetchAirtable(TABLE_TICKETS),
              fetchAirtable(TABLE_STATIONS),
            ]);

          let partnersRecords = [];
          try {
            partnersRecords = await fetchAirtable(TABLE_PARTNERS);
          } catch (error) {
            console.warn(
              'Tabela Parceiros não carregada. O dashboard continuará sem dados de parceiro.',
              error,
            );
            partnersRecords = [];
          }

          stations = stationsRecords.map((record) => ({
            id: record.id,
            name: field(
              record.fields,
              ['Name', 'Nome Estação', 'Nome', 'Estação'],
              record.id,
            ),
            chargeBoxId: field(
              record.fields,
              ['chargeBoxId', 'ChargeBoxId', 'charge_box_id'],
              '',
            ),
            contrato: field(record.fields, ['Contrato'], ''),
            tipoConector: field(
              record.fields,
              ['Tipo', 'Tipo Conector', 'Tipo de Conector'],
              '',
            ),
          }));
          const pedIds = getDashboardBreakdownIds(resolveTheme());
          if (pedIds.length > 0) {
            stations.forEach((item) => {
              if (!item.contrato && item.chargeBoxId) {
                item.contrato = pedIds.includes(item.chargeBoxId)
                  ? 'P&D'
                  : 'Novos Negócios';
              }
            });
          }
          stationsMap = Object.fromEntries(
            stations.map((item) => [item.id, item.name]),
          );
          stationsFullMap = Object.fromEntries(
            stations.map((item) => [item.id, item]),
          );

          partners = partnersRecords.map((record) => ({
            id: record.id,
            name: field(
              record.fields,
              ['Nome Parceiro', 'Name', 'Nome', 'Parceiro', 'Responsável'],
              record.id,
            ),
            cnpj: field(record.fields, ['CNPJ']),
            responsible: field(record.fields, ['Responsável', 'Responsavel']),
            phone: field(record.fields, ['Telefone']),
            email: field(record.fields, ['Email', 'E-mail']),
            city: field(record.fields, ['Cidade']),
            nr10: field(record.fields, ['NR10']),
            notes: field(record.fields, ['Observações', 'Observacoes']),
          }));

          partnersMap = Object.fromEntries(
            partners.map((item) => [item.id, item.name]),
          );

          ticketsMap = Object.fromEntries(
            ticketsRecords.map((record) => [
              record.id,
              field(
                record.fields,
                ['Chamado', 'Numero Chamado', 'Número Chamado', 'Nº Chamado'],
                record.id,
              ),
            ]),
          );

          maintenancesMap = Object.fromEntries(
            maintenancesRecords.map((record) => [
              record.id,
              field(
                record.fields,
                ['Protocolo', 'ID', 'Numero Protocolo', 'Número Protocolo'],
                record.id,
              ),
            ]),
          );

          maintenances = maintenancesRecords.map((record) => {
            const f = record.fields;
            const rawCarregador = f['Carregador'];
            const carregadorId = Array.isArray(rawCarregador)
              ? rawCarregador[0]
              : rawCarregador || null;
            const stationInfo = stationsFullMap[carregadorId] || {};
            return {
              date: field(f, ['Data']),
              status: field(f, ['Status']),
              time: field(f, ['Horário', 'Horario']),
              station: normalizeText(
                field(f, [
                  'Name (from Carregador)',
                  'Name (from Estação)',
                  'Name (from Estacao)',
                  'Nome (from Carregador)',
                  'Carregador',
                  'Estação',
                  'Estacao',
                ]),
                stationsMap,
              ),
              type: field(f, ['Tipo de manutenção', 'Tipo manutenção']),
              category: field(f, [
                'Categoria de Falha',
                'Categoria da Falha',
                'Categoria da falha',
              ]),
              severity: field(f, ['Severidade']),
              reason: field(f, ['Motivo']),
              workDone: field(f, [
                'O que foi feito',
                'O Que Foi Feito',
                'Serviço realizado',
                'Servicos realizados',
              ]),
              relatedTicket: normalizeText(
                field(f, [
                  'Chamado',
                  'Chamado relacionado',
                  'Chamado Relacionado',
                  'Ticket',
                  'Nº chamado',
                ]),
                ticketsMap,
              ),
              partner: normalizeText(
                field(f, [
                  'Parceiro',
                  'Parceiro acionado',
                  'Parceiro Acionado',
                  'Responsável externo',
                ]),
                partnersMap,
              ),
              responsible: field(f, ['Responsável', 'Responsavel']),
              protocol: field(f, [
                'Protocolo',
                'ID',
                'Numero Protocolo',
                'Número Protocolo',
              ]),
              evidence: field(
                f,
                [
                  'Fotos / Evidências',
                  'Fotos/Evidências',
                  'Fotos',
                  'Evidências',
                ],
                [],
              ),
              recurring:
                field(f, ['Recorrência', 'Recorrencia']) === 'Sim' ||
                field(f, ['Recorrência', 'Recorrencia']) === true,
              contrato: stationInfo.contrato || '',
              tipoConector: stationInfo.tipoConector || '',
              custo: field(f, ['Custo (R$)'], null),
            };
          });

          tickets = ticketsRecords.map((record) => {
            const f = record.fields;
            return {
              id: record.id,
              number: field(f, [
                'Chamado',
                'Numero Chamado',
                'Número Chamado',
                'Nº Chamado',
              ]),
              station: normalizeText(
                field(f, [
                  'Name (from Estação)',
                  'Name (from Estacao)',
                  'Nome (from Estação)',
                  'Estação',
                  'Estacao',
                ]),
                stationsMap,
              ),
              status: normalizeStatus(field(f, ['Status'])),
              severity: field(f, ['Severidade']) || '-',
              problem: field(f, ['Problema relatado', 'Problema Relatado']),
              requester: field(f, ['Solicitante']),
              partner: normalizeText(
                field(f, [
                  'Parceiro Acionado',
                  'Parceiro acionado',
                  'Parceiro',
                ]),
                partnersMap,
              ),
              relatedMaintenance: normalizeText(
                field(f, [
                  'Manutenções',
                  'Manutencoes',
                  'Manutenções vinculadas',
                  'Manutenção relacionada',
                  'Manutencao relacionada',
                  'Manutenção',
                ]),
                maintenancesMap,
              ),
            };
          });

          initFilters();
          initTicketStationOptions();
          initMaintenanceTicketOptions();
          hideLoadingState();
          render();
        } catch (error) {
          console.error(error);
          alert(
            'Erro ao carregar dados do Airtable. Abra o console com F12 para ver detalhes.',
          );
        }
      }

      function initFilters() {
        const currentValue = stationFilter.value || 'Todos';
        const stations = [
          ...new Set(
            [
              ...maintenances.map((item) => item.station),
              ...tickets.map((item) => item.station),
            ].filter(Boolean),
          ),
        ].sort();
        stationFilter.innerHTML = ['Todos', ...stations]
          .map((station) => `<option value="${station}">${station}</option>`)
          .join('');
        if (
          [...stationFilter.options].some(
            (option) => option.value === currentValue,
          )
        )
          stationFilter.value = currentValue;
      }

      function initTicketStationOptions() {
        const ticketStationSelect = document.getElementById('ticketStation');
        const maintenanceStationSelect =
          document.getElementById('maintenanceStation');

        const sortedStations = stations
          .slice()
          .filter((item) => item.id && item.name)
          .sort((a, b) => a.name.localeCompare(b.name));

        const options =
          '<option value="">Selecione uma estação</option>' +
          sortedStations
            .map((item) => `<option value="${item.id}">${item.name}</option>`)
            .join('');

        if (ticketStationSelect) ticketStationSelect.innerHTML = options;
        if (maintenanceStationSelect) {
          maintenanceStationSelect.innerHTML = options;
          if (sortedStations.length === 0) {
            maintenanceStationSelect.innerHTML =
              '<option value="">Nenhuma estação carregada</option>';
          }
        }
      }

      function initMaintenanceTicketOptions() {
        const ticketSelect = document.getElementById('maintenanceTicket');
        if (!ticketSelect) return;

        const activeTickets = tickets
          .slice()
          .filter(
            (item) =>
              !['Resolvido', 'Cancelado'].includes(
                normalizeStatus(item.status),
              ),
          )
          .sort((a, b) =>
            String(a.number || '').localeCompare(String(b.number || '')),
          );

        ticketSelect.innerHTML =
          '<option value="">Sem chamado vinculado</option>' +
          activeTickets
            .map(
              (item) =>
                `<option value="${item.id}">${item.number || item.id} — ${
                  item.station || 'Sem estação'
                } — ${item.problem || 'Sem descrição'}</option>`,
            )
            .join('');
      }

      function getFilteredMaintenances() {
        const station = stationFilter.value;
        const type = typeFilter.value;
        const status = statusFilter.value;
        const contrato = contratoFilter.value;
        const search = searchInput.value.trim().toLowerCase();
        const dateFrom = dateFromFilter.value
          ? parseDate(dateFromFilter.value)
          : null;
        const dateTo = dateToFilter.value
          ? parseDate(dateToFilter.value)
          : null;
        if (dateTo) dateTo.setHours(23, 59, 59, 999);
        return maintenances.filter((item) => {
          const matchesStation =
            station === 'Todos' || item.station === station;
          const matchesType = type === 'Todos' || item.type === type;
          const matchesStatus =
            status === 'Todos' || normalizeStatus(item.status) === status;
          const matchesContrato =
            contrato === 'Todos' || item.contrato === contrato;
          const itemDate = parseDate(item.date);
          const matchesDateFrom =
            !dateFrom || (itemDate && itemDate >= dateFrom);
          const matchesDateTo = !dateTo || (itemDate && itemDate <= dateTo);
          const matchesSearch =
            !search ||
            [item.station, item.reason, item.category, item.severity]
              .join(' ')
              .toLowerCase()
              .includes(search);
          return (
            matchesStation &&
            matchesType &&
            matchesStatus &&
            matchesContrato &&
            matchesDateFrom &&
            matchesDateTo &&
            matchesSearch
          );
        });
      }

      function getFilteredTickets() {
        const station = stationFilter.value;
        return tickets.filter(
          (item) => station === 'Todos' || item.station === station,
        );
      }

      function updateKpis() {
        const filteredMaintenances = getFilteredMaintenances();
        const filteredTickets = getFilteredTickets();
        document.getElementById('kpiOpenTickets').textContent =
          filteredTickets.filter((t) => isOpenStatus(t.status)).length;
        document.getElementById('kpiMaintenances').textContent =
          filteredMaintenances.length;
        document.getElementById('kpiCorrective').textContent =
          filteredMaintenances.filter((m) => m.type === 'Corretiva').length;
        document.getElementById('kpiRecurring').textContent =
          filteredMaintenances.filter((m) => m.recurring).length;
      }

      function groupByDate(items) {
        const grouped = {};
        items.forEach((item) => {
          const date = parseDate(item.date);
          if (!date || Number.isNaN(date.getTime())) return;
          const key = date.toISOString().slice(0, 10);
          grouped[key] = (grouped[key] || 0) + 1;
        });
        return Object.keys(grouped)
          .sort()
          .map((date) => ({ date: formatDate(date), total: grouped[date] }));
      }

      function updateCharts() {
        const filtered = getFilteredMaintenances();
        const timelineData = groupByDate(filtered);
        if (timelineChart) timelineChart.destroy();
        timelineChart = new Chart(document.getElementById('timelineChart'), {
          type: 'line',
          data: {
            labels: timelineData.map((item) => item.date),
            datasets: [
              {
                label: 'Manutenções',
                data: timelineData.map((item) => item.total),
                borderWidth: 3,
                tension: 0.35,
              },
            ],
          },
          options: {
            responsive: true,
            plugins: { legend: { display: false } },
            scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
          },
        });
        const preventive = filtered.filter(
          (m) => m.type === 'Preventiva',
        ).length;
        const corrective = filtered.filter(
          (m) => m.type === 'Corretiva',
        ).length;
        if (typeChart) typeChart.destroy();
        typeChart = new Chart(document.getElementById('typeChart'), {
          type: 'doughnut',
          data: {
            labels: ['Preventiva', 'Corretiva'],
            datasets: [{ data: [preventive, corrective] }],
          },
          options: {
            responsive: true,
            plugins: { legend: { position: 'bottom' } },
          },
        });

        const corrOnly = filtered.filter((m) => m.type === 'Corretiva');
        const rankMap = {};
        corrOnly.forEach((m) => {
          const k = m.station || 'Sem nome';
          rankMap[k] = (rankMap[k] || 0) + 1;
        });
        const rankData = Object.entries(rankMap)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 10);
        if (rankingChart) rankingChart.destroy();
        if (rankData.length === 0) {
          document.getElementById('rankingChart').style.display = 'none';
        } else {
          document.getElementById('rankingChart').style.display = '';
          rankingChart = new Chart(document.getElementById('rankingChart'), {
            type: 'bar',
            data: {
              labels: rankData.map((d) => d[0]),
              datasets: [
                {
                  label: 'Corretivas',
                  data: rankData.map((d) => d[1]),
                  backgroundColor: '#f87171',
                  borderRadius: 5,
                },
              ],
            },
            options: {
              indexAxis: 'y',
              responsive: true,
              plugins: { legend: { display: false } },
              scales: { x: { beginAtZero: true, ticks: { precision: 0 } } },
            },
          });
        }
      }

      function statusPill(status) {
        const cleanStatus = normalizeStatus(status);
        const color =
          cleanStatus === 'Resolvido'
            ? 'green'
            : cleanStatus === 'Aberto'
            ? 'red'
            : cleanStatus === 'Parceiro acionado'
            ? 'yellow'
            : 'blue';
        return `<span class="pill ${color}">${cleanStatus}</span>`;
      }

      function typePill(type) {
        const color = type === 'Corretiva' ? 'yellow' : 'blue';
        return `<span class="pill ${color}">${type || '-'}</span>`;
      }

      function escapeHtml(value) {
        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function contratoPill(programa) {
        if (programa === 'P&D') return '<span class="pill purple">P&D</span>';
        if (programa === 'Novos Negócios')
          return '<span class="pill blue">NN</span>';
        return programa
          ? `<span class="pill gray">${escapeHtml(programa)}</span>`
          : '-';
      }

      function updateTables() {
        const openTickets = getFilteredTickets().filter((t) =>
          isOpenStatus(t.status),
        );
        document.getElementById('openTicketsTable').innerHTML =
          openTickets.length
            ? openTickets
                .map(
                  (item) => `
          <tr><td>${item.number || '-'}</td><td>${
                    item.station || '-'
                  }</td><td>${statusPill(item.status)}</td><td>${
                    item.severity || '-'
                  }</td></tr>
        `,
                )
                .join('')
            : '<tr><td colspan="4" class="muted">Nenhum chamado aberto encontrado.</td></tr>';

        const latest = getFilteredMaintenances()
          .slice()
          .sort((a, b) => {
            const dateA = parseDate(a.date);
            const dateB = parseDate(b.date);
            return (dateB?.getTime() || 0) - (dateA?.getTime() || 0);
          })
          .slice(0, 8);
        document.getElementById('maintenanceTable').innerHTML = latest.length
          ? latest
              .map(
                (item) => `
          <tr><td>${formatDate(item.date)}</td><td>${
                  item.station || '-'
                }</td><td>${typePill(item.type)}</td><td>${
                  item.reason || '-'
                }</td></tr>
        `,
              )
              .join('')
          : '<tr><td colspan="4" class="muted">Nenhuma manutenção encontrada.</td></tr>';
      }

      function renderPartners() {
        const search = (partnersSearch?.value || '').trim().toLowerCase();

        const filtered = partners.filter((item) => {
          const text = [
            item.name,
            item.cnpj,
            item.responsible,
            item.phone,
            item.email,
            item.city,
            item.nr10,
            item.notes,
          ]
            .join(' ')
            .toLowerCase();

          return !search || text.includes(search);
        });

        partnersTableBody.innerHTML = filtered.length
          ? filtered
              .map(
                (item) => `
            <tr>
              <td>${item.name || '-'}</td>
              <td>${item.cnpj || '-'}</td>
              <td>${item.responsible || '-'}</td>
              <td>${item.phone || '-'}</td>
              <td>${item.email || '-'}</td>
              <td>${item.city || '-'}</td>
              <td>${
                item.nr10 === true
                  ? 'Sim'
                  : item.nr10 === false
                  ? 'Não'
                  : item.nr10 || '-'
              }</td>
              <td>${item.notes || '-'}</td>
            </tr>
          `,
              )
              .join('')
          : '<tr><td colspan="8" class="muted">Nenhum parceiro encontrado.</td></tr>';
      }

      function openPartnersModal() {
        renderPartners();
        partnersModal.classList.add('open');
      }

      function closePartnersModal() {
        partnersModal.classList.remove('open');
        partnerForm.classList.remove('open');
        partnerForm.reset();
        partnerMessage.className = 'message';
        partnerMessage.textContent = '';
      }

      function togglePartnerForm() {
        partnerForm.classList.toggle('open');
        partnerMessage.className = 'message';
        partnerMessage.textContent = '';
      }

      async function submitPartner(event) {
        event.preventDefault();

        const name = document.getElementById('partnerName').value.trim();
        const cnpj = document.getElementById('partnerCnpj').value.trim();
        const responsible = document
          .getElementById('partnerResponsible')
          .value.trim();
        const phone = document.getElementById('partnerPhone').value.trim();
        const email = document.getElementById('partnerEmail').value.trim();
        const city = document.getElementById('partnerCity').value.trim();
        const nr10Raw = document.getElementById('partnerNr10').value;
        const notes = document.getElementById('partnerNotes').value.trim();

        if (!name) {
          partnerMessage.className = 'message error';
          partnerMessage.textContent = 'Informe o nome do parceiro.';
          return;
        }

        savePartnerBtn.disabled = true;
        savePartnerBtn.textContent = 'Salvando...';

        try {
          const fields = {
            'Nome Parceiro': name,
            CNPJ: cnpj,
            Responsável: responsible,
            Telefone: phone,
            Email: email,
            Cidade: city,
            Observações: notes,
          };

          if (nr10Raw === 'true') fields.NR10 = true;
          if (nr10Raw === 'false') fields.NR10 = false;

          Object.keys(fields).forEach((key) => {
            if (
              fields[key] === '' ||
              fields[key] === null ||
              fields[key] === undefined
            )
              delete fields[key];
          });

          await createAirtableRecord(TABLE_PARTNERS, fields);

          partnerMessage.className = 'message success';
          partnerMessage.textContent =
            'Parceiro cadastrado com sucesso. Atualizando lista...';

          await loadAirtableData();
          renderPartners();

          setTimeout(() => {
            partnerForm.reset();
            partnerForm.classList.remove('open');
            partnerMessage.className = 'message';
            partnerMessage.textContent = '';
          }, 900);
        } catch (error) {
          console.error('Erro ao salvar parceiro:', error);
          partnerMessage.className = 'message error';
          partnerMessage.textContent =
            'Erro ao salvar parceiro. Verifique o Console com F12.';
        } finally {
          savePartnerBtn.disabled = false;
          savePartnerBtn.textContent = 'Salvar parceiro';
        }
      }

      function render() {
        updateKpis();
        updateCharts();
        updateTables();
      }

      function showLoadingState() {
        ['kpiOpenTickets', 'kpiMaintenances', 'kpiCorrective', 'kpiRecurring'].forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.classList.add('loading');
          if (el?.previousElementSibling) el.previousElementSibling.classList.add('loading');
        });
        const ticketsBody = document.getElementById('openTicketsTable');
        if (ticketsBody) {
          ticketsBody.innerHTML = '<tr class="skeleton-row"><td>-</td><td>-</td><td>-</td><td>-</td></tr>'.repeat(3);
        }
        const maintenanceBody = document.getElementById('maintenanceTable');
        if (maintenanceBody) {
          maintenanceBody.innerHTML = '<tr class="skeleton-row"><td>-</td><td>-</td><td>-</td><td>-</td></tr>'.repeat(4);
        }
      }

      function hideLoadingState() {
        ['kpiOpenTickets', 'kpiMaintenances', 'kpiCorrective', 'kpiRecurring'].forEach((id) => {
          const el = document.getElementById(id);
          if (el) el.classList.remove('loading');
          if (el?.previousElementSibling) el.previousElementSibling.classList.remove('loading');
        });
      }

      function uniqueValues(values) {
        return [...new Set(values.filter(Boolean))].sort();
      }

      function setOptions(select, values, allLabel = 'Todos') {
        select.innerHTML = [allLabel, ...values]
          .map((value) => `<option value="${value}">${value}</option>`)
          .join('');
      }

      function openRecordsModal(mode) {
        recordsMode = mode;
        recordsSearch.value = '';

        const downloadPdfBtn = document.getElementById('downloadPdfBtn');
        if (downloadPdfBtn) {
          downloadPdfBtn.style.display =
            mode === 'maintenances' ? 'inline-flex' : 'none';
        }

        const allStations = uniqueValues([
          ...tickets.map((item) => item.station),
          ...maintenances.map((item) => item.station),
        ]);

        setOptions(recordsStationFilter, allStations);

        if (mode === 'tickets') {
          recordsModalTitle.textContent = 'Todos os chamados';
          recordsModalSubtitle.textContent =
            'Lista completa dos chamados registrados no Airtable.';
          setOptions(
            recordsStatusFilter,
            uniqueValues(tickets.map((item) => normalizeStatus(item.status))),
            'Todos',
          );
          setOptions(
            recordsSeverityFilter,
            uniqueValues(
              tickets.map((item) => item.severity).filter((v) => v !== '-'),
            ),
            'Todas',
          );
        } else {
          recordsModalTitle.textContent = 'Todas as manutenções';
          recordsModalSubtitle.textContent =
            'Lista completa das manutenções registradas no Airtable.';
          setOptions(
            recordsStatusFilter,
            uniqueValues(maintenances.map((item) => item.type)),
            'Todos',
          );
          setOptions(
            recordsSeverityFilter,
            uniqueValues(
              maintenances
                .map((item) => item.severity)
                .filter((v) => v !== '-'),
            ),
            'Todas',
          );
        }

        renderRecordsTable();
        recordsModal.classList.add('open');
      }

      function closeRecordsModal() {
        recordsModal.classList.remove('open');
      }

      function recordMatchesSearch(record, search) {
        if (!search) return true;
        return Object.values(record)
          .join(' ')
          .toLowerCase()
          .includes(search.toLowerCase());
      }

      function renderRecordsTable() {
        const search = recordsSearch.value.trim();
        const station = recordsStationFilter.value;
        const status = recordsStatusFilter.value;
        const severity = recordsSeverityFilter.value;
        const contrato = recordsContratoFilter.value;
        const dateFrom = recordsDateFromFilter.value
          ? parseDate(recordsDateFromFilter.value)
          : null;
        const dateTo = recordsDateToFilter.value
          ? parseDate(recordsDateToFilter.value)
          : null;
        if (dateTo) dateTo.setHours(23, 59, 59, 999);

        if (recordsMode === 'tickets') {
          let data = tickets.slice();

          data = data.filter((item) => {
            const matchesStation =
              station === 'Todos' || item.station === station;
            const matchesStatus =
              status === 'Todos' || normalizeStatus(item.status) === status;
            const matchesSeverity =
              severity === 'Todas' || item.severity === severity;
            return (
              matchesStation &&
              matchesStatus &&
              matchesSeverity &&
              recordMatchesSearch(item, search)
            );
          });

          recordsTableHead.innerHTML = `
            <tr>
              <th>Chamado</th>
              <th>Estação</th>
              <th>Status</th>
              <th>Severidade</th>
              <th>Problema</th>
              <th>Solicitante</th>
              <th>Parceiro</th>
              <th>Manutenção relacionada</th>
            </tr>
          `;

          recordsTableBody.innerHTML = data.length
            ? data
                .map(
                  (item) => `
              <tr>
                <td>${item.number || '-'}</td>
                <td>${item.station || '-'}</td>
                <td>${statusPill(item.status)}</td>
                <td>${item.severity || '-'}</td>
                <td>${item.problem || '-'}</td>
                <td>${item.requester || '-'}</td>
                <td>${item.partner || '-'}</td>
                <td>${item.relatedMaintenance || '-'}</td>
              </tr>
            `,
                )
                .join('')
            : '<tr><td colspan="12" class="muted">Nenhum registro encontrado.</td></tr>';
        } else {
          let data = maintenances.slice();

          data = data.filter((item) => {
            const matchesStation =
              station === 'Todos' || item.station === station;
            const matchesType = status === 'Todos' || item.type === status;
            const matchesSeverity =
              severity === 'Todas' || item.severity === severity;
            const matchesContrato =
              contrato === 'Todos' || item.contrato === contrato;
            const itemDate = parseDate(item.date);
            const matchesDateFrom =
              !dateFrom || (itemDate && itemDate >= dateFrom);
            const matchesDateTo =
              !dateTo || (itemDate && itemDate <= dateTo);
            return (
              matchesStation &&
              matchesType &&
              matchesSeverity &&
              matchesContrato &&
              matchesDateFrom &&
              matchesDateTo &&
              recordMatchesSearch(item, search)
            );
          });

          data = data.sort((a, b) => {
            const dateA = parseDate(a.date);
            const dateB = parseDate(b.date);
            return (dateB?.getTime() || 0) - (dateA?.getTime() || 0);
          });

          recordsTableHead.innerHTML = `
            <tr>
              <th>Data</th>
              <th>Horário</th>
              <th>Estação</th>
              <th>Tipo</th>
              <th>Categoria</th>
              <th>Severidade</th>
              <th>Motivo</th>
              <th>O que foi feito</th>
              <th>Chamado relacionado</th>
              <th>Parceiro</th>
              <th>Protocolo</th>
              <th>Status</th>
              <th>Contrato</th>
              <th>Custo (R$)</th>
            </tr>
          `;

          recordsTableBody.innerHTML = data.length
            ? data
                .map(
                  (item) => `
              <tr>
                <td>${formatDate(item.date)}</td>
                <td>${item.time || '-'}</td>
                <td>${item.station || '-'}</td>
                <td>${typePill(item.type)}</td>
                <td>${item.category || '-'}</td>
                <td>${item.severity || '-'}</td>
                <td>${item.reason || '-'}</td>
                <td>${item.workDone || '-'}</td>
                <td>${item.relatedTicket || '-'}</td>
                <td>${item.partner || '-'}</td>
                <td>${item.protocol || '-'}</td>
                <td>${item.status ? statusPill(item.status) : '-'}</td>
                <td>${contratoPill(item.contrato)}</td>
                <td>${
                  item.custo != null
                    ? 'R$ ' +
                      Number(item.custo).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                      })
                    : '-'
                }</td>
              </tr>
            `,
                )
                .join('')
            : '<tr><td colspan="14" class="muted">Nenhum registro encontrado.</td></tr>';
        }
      }

      async function imageUrlToDataUrl(url) {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        } catch (error) {
          console.warn(
            'Não foi possível carregar imagem para PDF:',
            url,
            error,
          );
          return null;
        }
      }

      function getFilteredMaintenancesForPdf() {
        const search = recordsSearch.value.trim();
        const station = recordsStationFilter.value;
        const status = recordsStatusFilter.value;
        const severity = recordsSeverityFilter.value;
        const contrato = recordsContratoFilter.value;
        const dateFrom = recordsDateFromFilter.value
          ? parseDate(recordsDateFromFilter.value)
          : null;
        const dateTo = recordsDateToFilter.value
          ? parseDate(recordsDateToFilter.value)
          : null;
        if (dateTo) dateTo.setHours(23, 59, 59, 999);

        return maintenances
          .slice()
          .filter((item) => {
            const matchesStation =
              station === 'Todos' || item.station === station;
            const matchesType = status === 'Todos' || item.type === status;
            const matchesSeverity =
              severity === 'Todas' || item.severity === severity;
            const matchesContrato =
              contrato === 'Todos' || item.contrato === contrato;
            const itemDate = parseDate(item.date);
            const matchesDateFrom =
              !dateFrom || (itemDate && itemDate >= dateFrom);
            const matchesDateTo =
              !dateTo || (itemDate && itemDate <= dateTo);
            return (
              matchesStation &&
              matchesType &&
              matchesSeverity &&
              matchesContrato &&
              matchesDateFrom &&
              matchesDateTo &&
              recordMatchesSearch(item, search)
            );
          })
          .sort((a, b) => {
            const dateA = parseDate(a.date);
            const dateB = parseDate(b.date);
            return (dateB?.getTime() || 0) - (dateA?.getTime() || 0);
          });
      }

      async function downloadRecordsPdf() {
        if (recordsMode !== 'maintenances') {
          alert(
            'Por enquanto o PDF profissional é gerado apenas para manutenções. Abra "Ver todas" em Últimas manutenções.',
          );
          return;
        }

        const records = getFilteredMaintenancesForPdf();
        if (!records.length) {
          alert('Nenhuma manutenção encontrada para exportar.');
          return;
        }

        const button = document.getElementById('downloadPdfBtn');
        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Gerando PDF...';

        try {
          const { jsPDF } = window.jspdf;
          const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4',
          });
          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();
          const primary = [15, 23, 42];
          const muted = [85, 99, 115];
          const border = [226, 232, 240];

          const footer = () => {
            const page = doc.internal.getNumberOfPages();
            doc.setFontSize(8);
            doc.setTextColor(100, 116, 139);
            doc.text(
              'Documento gerado automaticamente pelo sistema Move Operations.',
              14,
              pageHeight - 8,
            );
            doc.text(`Página ${page}`, pageWidth - 25, pageHeight - 8);
          };

          const header = (title = 'Relatório Operacional de Manutenções') => {
            doc.setFillColor(255, 255, 255);
            doc.rect(0, 0, pageWidth, 28, 'F');
            doc.setTextColor(...primary);
            doc.setFont(undefined, 'bold');
            doc.setFontSize(20);
            doc.text(title, 14, 16);
            doc.setFont(undefined, 'normal');
            doc.setFontSize(9);
            doc.setTextColor(...muted);
            doc.text(
              `Gerado em: ${new Date().toLocaleString('pt-BR')}`,
              14,
              23,
            );
          };

          const kpi = (x, y, w, title, value) => {
            doc.setDrawColor(...border);
            doc.setFillColor(248, 250, 252);
            doc.roundedRect(x, y, w, 22, 2, 2, 'FD');
            doc.setTextColor(...primary);
            doc.setFont(undefined, 'bold');
            doc.setFontSize(14);
            doc.text(String(value), x + w / 2, y + 9, { align: 'center' });
            doc.setTextColor(...muted);
            doc.setFont(undefined, 'normal');
            doc.setFontSize(8);
            doc.text(title, x + w / 2, y + 17, { align: 'center' });
          };

          header();
          const corrective = records.filter(
            (r) => r.type === 'Corretiva',
          ).length;
          const preventive = records.filter(
            (r) => r.type === 'Preventiva',
          ).length;
          const recurrings = records.filter((r) => r.recurring).length;
          const resolved = records.filter(
            (r) => r.status === 'Resolvido',
          ).length;

          kpi(14, 35, 48, 'Manutenções', records.length);
          kpi(68, 35, 48, 'Corretivas', corrective);
          kpi(122, 35, 48, 'Preventivas', preventive);
          kpi(176, 35, 48, 'Recorrências', recurrings);
          kpi(230, 35, 48, 'Resolvidas', resolved);

          doc.autoTable({
            startY: 66,
            head: [
              [
                'Data',
                'Estação',
                'Tipo',
                'Categoria',
                'Severidade',
                'Motivo',
                'Responsável/Parceiro',
                'Protocolo',
              ],
            ],
            body: records.map((item) => [
              formatDate(item.date),
              item.station || '-',
              item.type || '-',
              item.category || '-',
              item.severity || '-',
              item.reason || '-',
              item.responsible || item.partner || '-',
              item.protocol || '-',
            ]),
            theme: 'grid',
            styles: { fontSize: 7.8, cellPadding: 2, valign: 'top' },
            headStyles: {
              fillColor: primary,
              textColor: [255, 255, 255],
              fontStyle: 'bold',
            },
            columnStyles: {
              0: { cellWidth: 20 },
              1: { cellWidth: 50 },
              2: { cellWidth: 22 },
              3: { cellWidth: 36 },
              4: { cellWidth: 24 },
              5: { cellWidth: 58 },
              6: { cellWidth: 40 },
              7: { cellWidth: 34 },
            },
            didDrawPage: footer,
          });

          for (const item of records) {
            doc.addPage();
            header('Detalhamento da Manutenção');

            doc.setTextColor(...primary);
            doc.setFont(undefined, 'bold');
            doc.setFontSize(14);
            doc.text(item.protocol || 'Manutenção sem protocol', 14, 38);
            doc.setTextColor(...muted);
            doc.setFont(undefined, 'normal');
            doc.setFontSize(9);
            doc.text(
              `${formatDate(item.date)} ${item.time || ''} • ${
                item.station || '-'
              }`,
              14,
              45,
            );

            doc.autoTable({
              startY: 54,
              theme: 'grid',
              styles: { fontSize: 8, cellPadding: 2.2, valign: 'top' },
              columnStyles: {
                0: {
                  fontStyle: 'bold',
                  cellWidth: 38,
                  fillColor: [248, 250, 252],
                },
                1: { cellWidth: 96 },
                2: {
                  fontStyle: 'bold',
                  cellWidth: 38,
                  fillColor: [248, 250, 252],
                },
                3: { cellWidth: 96 },
              },
              body: [
                ['Tipo', item.type || '-', 'Status', item.status || '-'],
                [
                  'Categoria',
                  item.category || '-',
                  'Severidade',
                  item.severity || '-',
                ],
                [
                  'Parceiro',
                  item.partner || '-',
                  'Chamado',
                  item.relatedTicket || '-',
                ],
              ],
            });

            let y = doc.lastAutoTable.finalY + 10;

            const section = (title, text) => {
              doc.setTextColor(...primary);
              doc.setFont(undefined, 'bold');
              doc.setFontSize(10);
              doc.text(title, 14, y);
              y += 6;
              doc.setTextColor(30, 41, 59);
              doc.setFont(undefined, 'normal');
              doc.setFontSize(9);
              const lines = doc.splitTextToSize(text || '-', pageWidth - 28);
              doc.text(lines, 14, y);
              y += lines.length * 4.2 + 8;
            };

            section('Motivo / causa', item.reason);
            section('O que foi feito', item.workDone);

            doc.setTextColor(...primary);
            doc.setFont(undefined, 'bold');
            doc.setFontSize(10);
            doc.text('Evidências fotográficas', 14, y);
            y += 6;

            const evidenceList = Array.isArray(item.evidence)
              ? item.evidence
              : [];
            if (!evidenceList.length) {
              doc.setTextColor(...muted);
              doc.setFont(undefined, 'normal');
              doc.setFontSize(9);
              doc.text('Nenhuma evidência anexada.', 14, y);
            } else {
              let x = 14;
              let count = 0;
              for (const evidence of evidenceList.slice(0, 8)) {
                const url =
                  evidence.url ||
                  evidence.thumbnails?.large?.url ||
                  evidence.thumbnails?.full?.url;
                if (!url) continue;
                const dataUrl = await imageUrlToDataUrl(url);
                if (!dataUrl) continue;
                if (y > pageHeight - 55) {
                  doc.addPage();
                  header('Evidências da Manutenção');
                  y = 38;
                  x = 14;
                }
                try {
                  const format = dataUrl.includes('image/png') ? 'PNG' : 'JPEG';
                  doc.addImage(dataUrl, format, x, y, 56, 40);
                  count += 1;
                  x += 62;
                  if (x > pageWidth - 65) {
                    x = 14;
                    y += 48;
                  }
                } catch (error) {
                  console.warn('Erro ao inserir imagem no PDF:', error);
                }
              }
              if (count === 0) {
                doc.setTextColor(...muted);
                doc.setFont(undefined, 'normal');
                doc.setFontSize(9);
                doc.text(
                  'Evidências encontradas, mas não foi possível carregar as imagens no PDF.',
                  14,
                  y,
                );
              }
            }
            footer();
          }

          doc.save(
            `relatorio_manutencoes_${new Date()
              .toISOString()
              .slice(0, 10)}.pdf`,
          );
        } finally {
          button.disabled = false;
          button.textContent = originalText;
        }
      }

      function todayIsoDate() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      function nowTime() {
        const now = new Date();
        return `${String(now.getHours()).padStart(2, '0')}:${String(
          now.getMinutes(),
        ).padStart(2, '0')}`;
      }

      function openMaintenanceModal() {
        maintenanceMessage.className = 'message';
        maintenanceMessage.textContent = '';
        initTicketStationOptions();
        initMaintenanceTicketOptions();
        document.getElementById('maintenanceDate').value = todayIsoDate();
        document.getElementById('maintenanceTime').value = nowTime();
        maintenanceModal.classList.add('open');
      }

      function closeMaintenanceModal() {
        maintenanceModal.classList.remove('open');
        maintenanceForm.reset();
        maintenanceMessage.className = 'message';
        maintenanceMessage.textContent = '';
      }

      function parseDurationToSeconds(value) {
        if (!value) return '';

        const raw = String(value).trim().toLowerCase();

        // Format HH:MM or H:MM
        if (/^\d{1,2}:\d{2}$/.test(raw)) {
          const [hours, minutes] = raw.split(':').map(Number);
          return hours * 3600 + minutes * 60;
        }

        // Format 2h, 2 h, 2h30, 2h 30min
        const hourMatch = raw.match(/(\d+(?:[.,]\d+)?)\s*h/);
        const minuteMatch = raw.match(/(\d+)\s*(min|m)\b/);

        if (hourMatch || minuteMatch) {
          const hours = hourMatch
            ? parseFloat(hourMatch[1].replace(',', '.'))
            : 0;
          const minutes = minuteMatch ? parseInt(minuteMatch[1], 10) : 0;
          return Math.round(hours * 3600 + minutes * 60);
        }

        // Plain number: treat as minutes
        if (/^\d+(?:[.,]\d+)?$/.test(raw)) {
          return Math.round(parseFloat(raw.replace(',', '.')) * 60);
        }

        return '';
      }

      async function submitMaintenance(event) {
        event.preventDefault();

        const stationId = document.getElementById('maintenanceStation').value;
        const ticketId = document.getElementById('maintenanceTicket').value;
        const date = document.getElementById('maintenanceDate').value;
        const time = document.getElementById('maintenanceTime').value;
        const type = document.getElementById('maintenanceType').value;
        const category = document.getElementById('maintenanceCategory').value;
        const severity = document.getElementById('maintenanceSeverity').value;
        const status = document.getElementById('maintenanceStatus').value;
        const reason = document
          .getElementById('maintenanceReason')
          .value.trim();
        const action = document
          .getElementById('maintenanceAction')
          .value.trim();
        const requester = document
          .getElementById('maintenanceRequester')
          .value.trim();
        const responsible = document
          .getElementById('maintenanceResponsible')
          .value.trim();
        const totalTime = document
          .getElementById('maintenanceTotalTime')
          .value.trim();
        const totalTimeSeconds = parseDurationToSeconds(totalTime);
        const recurrence = document.getElementById(
          'maintenanceRecurrence',
        ).value;

        if (!stationId || !date || !type || !reason) {
          maintenanceMessage.className = 'message error';
          maintenanceMessage.textContent =
            'Preencha data, estação, tipo e motivo.';
          return;
        }

        saveMaintenanceBtn.disabled = true;
        saveMaintenanceBtn.textContent = 'Salvando...';

        try {
          maintenanceMessage.className = 'message';
          maintenanceMessage.textContent =
            'Enviando evidências e registrando manutenção...';

          const maintenanceEvidence = await uploadFilesToCloudinary(
            'maintenanceFiles',
          );

          const fields = {
            Data: date,
            Horário: time,
            Carregador: [stationId],
            Chamado: ticketId ? [ticketId] : '',
            'Tipo de manutenção': type,
            'Categoria de Falha': category,
            Severidade: severity,
            Status: status,
            Motivo: reason,
            'O que foi feito': action,
            Solicitante: requester,
            Responsável: responsible,
            'Duração da manutenção (min)': totalTimeSeconds,
            Recorrência: recurrence,
            'Custo (R$)': document.getElementById('maintenanceCusto').value
              ? parseFloat(document.getElementById('maintenanceCusto').value)
              : undefined,
            'Fotos / Evidências': maintenanceEvidence,
          };

          Object.keys(fields).forEach((key) => {
            if (
              fields[key] === '' ||
              fields[key] === null ||
              fields[key] === undefined ||
              (Array.isArray(fields[key]) && fields[key].length === 0)
            ) {
              delete fields[key];
            }
          });

          await createAirtableRecord(TABLE_MAINTENANCES, fields);

          maintenanceMessage.className = 'message success';
          maintenanceMessage.textContent =
            'Manutenção registrada com sucesso. Atualizando dashboard...';

          await loadAirtableData();

          setTimeout(closeMaintenanceModal, 900);
        } catch (error) {
          console.error(error);
          maintenanceMessage.className = 'message error';
          maintenanceMessage.textContent =
            'Erro ao registrar manutenção. Verifique o console com F12.';
        } finally {
          saveMaintenanceBtn.disabled = false;
          saveMaintenanceBtn.textContent = 'Salvar manutenção';
        }
      }

      function openTicketModal() {
        ticketMessage.className = 'message';
        ticketMessage.textContent = '';
        ticketModal.classList.add('open');
      }

      function closeTicketModal() {
        ticketModal.classList.remove('open');
        ticketForm.reset();
        ticketMessage.className = 'message';
        ticketMessage.textContent = '';
      }

      async function submitTicket(event) {
        event.preventDefault();

        const stationId = document.getElementById('ticketStation').value;
        const severity = document.getElementById('ticketSeverity').value;
        const origin = document.getElementById('ticketOrigin').value;
        const problem = document.getElementById('ticketProblem').value.trim();
        const requester = document
          .getElementById('ticketRequester')
          .value.trim();
        const phone = document.getElementById('ticketPhone').value.trim();

        if (!stationId || !problem) {
          ticketMessage.className = 'message error';
          ticketMessage.textContent =
            'Preencha a estação e o problema relatado.';
          console.warn('Chamado bloqueado por validação:', {
            stationId,
            problem,
          });
          return;
        }

        saveTicketBtn.disabled = true;
        saveTicketBtn.textContent = 'Salvando...';

        try {
          ticketMessage.className = 'message';
          ticketMessage.textContent =
            'Enviando evidências e criando chamado...';

          const ticketEvidence = await uploadFilesToCloudinary('ticketFiles');

          const fields = {
            Estação: [stationId],
            Severidade: severity,
            Origem: origin,
            'Problema relatado': problem,
            Solicitante: requester,
            'Telefone do solicitante': phone,
          };

          if (ticketEvidence.length > 0) {
            fields['Fotos / Evidências'] = ticketEvidence;
          }

          Object.keys(fields).forEach((key) => {
            if (
              fields[key] === '' ||
              fields[key] === null ||
              fields[key] === undefined ||
              (Array.isArray(fields[key]) && fields[key].length === 0)
            ) {
              delete fields[key];
            }
          });

          await createAirtableRecord(TABLE_TICKETS, fields);

          ticketMessage.className = 'message success';
          ticketMessage.textContent =
            'Chamado criado com sucesso. Atualizando dashboard...';

          await loadAirtableData();

          setTimeout(closeTicketModal, 900);
        } catch (error) {
          console.error('Erro no submitTicket:', error);
          ticketMessage.className = 'message error';
          ticketMessage.textContent =
            'Erro ao criar chamado. Veja o Console e Network no F12.';
        } finally {
          saveTicketBtn.disabled = false;
          saveTicketBtn.textContent = 'Salvar chamado';
        }
      }

      [
        stationFilter,
        typeFilter,
        statusFilter,
        contratoFilter,
        dateFromFilter,
        dateToFilter,
        searchInput,
      ].forEach((element) => {
        element.addEventListener('input', render);
        element.addEventListener('change', render);
      });
      const clearFiltersBtn = document.getElementById('clearFiltersBtn');
      if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', () => {
          stationFilter.value = 'Todos';
          typeFilter.value = 'Todos';
          statusFilter.value = 'Todos';
          searchInput.value = '';
          dateFromFilter.value = '';
          dateToFilter.value = '';
          contratoFilter.value = 'Todos';
          render();
        });
      }
      document
        .getElementById('viewAllTicketsBtn')
        .addEventListener('click', () => openRecordsModal('tickets'));
      document
        .getElementById('viewAllMaintenancesBtn')
        .addEventListener('click', () => openRecordsModal('maintenances'));
      document
        .getElementById('closeRecordsModalBtn')
        .addEventListener('click', closeRecordsModal);
      document
        .getElementById('closeRecordsFooterBtn')
        .addEventListener('click', closeRecordsModal);
      document
        .getElementById('downloadPdfBtn')
        .addEventListener('click', downloadRecordsPdf);
      recordsModal.addEventListener('click', (event) => {
        if (event.target === recordsModal) closeRecordsModal();
      });

      [
        recordsSearch,
        recordsStationFilter,
        recordsStatusFilter,
        recordsSeverityFilter,
        recordsContratoFilter,
        recordsDateFromFilter,
        recordsDateToFilter,
      ].forEach((element) => {
        element.addEventListener('input', renderRecordsTable);
        element.addEventListener('change', renderRecordsTable);
      });

      document
        .getElementById('openMaintenanceModalBtn')
        .addEventListener('click', openMaintenanceModal);
      document
        .getElementById('closeMaintenanceModalBtn')
        .addEventListener('click', closeMaintenanceModal);
      document
        .getElementById('cancelMaintenanceBtn')
        .addEventListener('click', closeMaintenanceModal);
      maintenanceModal.addEventListener('click', (event) => {
        if (event.target === maintenanceModal) closeMaintenanceModal();
      });
      maintenanceForm.addEventListener('submit', submitMaintenance);

      const maintenanceStationSelect =
        document.getElementById('maintenanceStation');
      if (maintenanceStationSelect) {
        maintenanceStationSelect.addEventListener('change', () => {
          const custo = calcDefaultCusto(
            stationsFullMap[maintenanceStationSelect.value],
          );
          const custoInput = document.getElementById('maintenanceCusto');
          if (custoInput) custoInput.value = custo !== null ? String(custo) : '';
        });
      }

      document
        .getElementById('openTicketModalBtn')
        .addEventListener('click', openTicketModal);
      document
        .getElementById('closeTicketModalBtn')
        .addEventListener('click', closeTicketModal);
      document
        .getElementById('cancelTicketBtn')
        .addEventListener('click', closeTicketModal);
      ticketModal.addEventListener('click', (event) => {
        if (event.target === ticketModal) closeTicketModal();
      });
      ticketForm.addEventListener('submit', submitTicket);

      document
        .getElementById('openPartnersModalBtn')
        .addEventListener('click', openPartnersModal);
      document
        .getElementById('closePartnersModalBtn')
        .addEventListener('click', closePartnersModal);
      document
        .getElementById('closePartnersFooterBtn')
        .addEventListener('click', closePartnersModal);
      document
        .getElementById('togglePartnerFormBtn')
        .addEventListener('click', togglePartnerForm);
      document
        .getElementById('cancelPartnerFormBtn')
        .addEventListener('click', togglePartnerForm);
      document
        .getElementById('refreshPartnersBtn')
        .addEventListener('click', async () => {
          await loadAirtableData();
          renderPartners();
        });
      partnerForm.addEventListener('submit', submitPartner);
      partnersSearch.addEventListener('input', renderPartners);
      partnersModal.addEventListener('click', (event) => {
        if (event.target === partnersModal) closePartnersModal();
      });

      showLoadingState();
      loadAirtableData();
    }

    boot();

    return () => {
      cancelled = true;
      const C = window.Chart;
      if (C && typeof C.getChart === 'function') {
        C.getChart('timelineChart')?.destroy();
        C.getChart('typeChart')?.destroy();
        C.getChart('rankingChart')?.destroy();
      }
    };
  }, []);

  return (
    <S.Root>
      <main className='page'>
        <section className='header'>
          <div>
            <h1>Dashboard de Manutenções</h1>
            <p>
              Visão operacional de tickets, manutenções, corrective,
              recorrências e histórico por estação.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <button className='btn secondary' id='openPartnersModalBtn'>
              Parceiros
            </button>
            <button className='btn secondary' id='openMaintenanceModalBtn'>
              + Registrar Manutenção
            </button>
            <button className='btn' id='openTicketModalBtn'>
              + Abrir Chamado
            </button>
          </div>
        </section>

        <section className='filters'>
          <div>
            <label>Carregador / Estação</label>
            <select id='stationFilter' />
          </div>
          <div>
            <label>Tipo</label>
            <select id='typeFilter'>
              <option value='Todos'>Todos</option>
              <option value='Preventiva'>Preventiva</option>
              <option value='Corretiva'>Corretiva</option>
            </select>
          </div>
          <div>
            <label>Status</label>
            <select id='statusFilter'>
              <option value='Todos'>Todos</option>
              <option value='Aberto'>Aberto</option>
              <option value='Em atendimento'>Em atendimento</option>
              <option value='Parceiro acionado'>Parceiro acionado</option>
              <option value='Resolvido'>Resolvido</option>
              <option value='Cancelado'>Cancelado</option>
            </select>
          </div>
          <div>
            <label>Buscar</label>
            <input id='searchInput' placeholder='Motivo, cidade, estação...' />
          </div>
          <div>
            <label>Contrato</label>
            <select id='contratoFilter'>
              <option value='Todos'>Todos</option>
              <option value='P&D'>P&amp;D</option>
              <option value='Novos Negócios'>Novos Negócios</option>
            </select>
          </div>
          <div>
            <label>De</label>
            <input id='dateFromFilter' type='date' />
          </div>
          <div>
            <label>Até</label>
            <input id='dateToFilter' type='date' />
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <button
              className='btn secondary'
              id='clearFiltersBtn'
              style={{ width: '100%' }}
            >
              Limpar filtros
            </button>
          </div>
        </section>

        <section className='kpis'>
          <div className='card'>
            <div className='kpi-title'>Chamados abertos</div>
            <div className='kpi-value' id='kpiOpenTickets'>
              0
            </div>
          </div>
          <div className='card'>
            <div className='kpi-title'>Manutenções</div>
            <div className='kpi-value' id='kpiMaintenances'>
              0
            </div>
          </div>
          <div className='card'>
            <div className='kpi-title'>Corretivas</div>
            <div className='kpi-value' id='kpiCorrective'>
              0
            </div>
          </div>
          <div className='card'>
            <div className='kpi-title'>Recorrências</div>
            <div className='kpi-value' id='kpiRecurring'>
              0
            </div>
          </div>
        </section>

        <section className='grid'>
          <div className='card'>
            <div className='section-title'>Gráfico temporal de manutenções</div>
            <canvas id='timelineChart' />
          </div>
          <div className='card'>
            <div className='section-title'>Preventivas x Corretivas</div>
            <canvas id='typeChart' />
          </div>
        </section>

        <section className='grid' style={{ gridTemplateColumns: '1fr' }}>
          <div className='card'>
            <div className='section-title'>
              Ranking — eletropostos com mais falhas corretivas (top 10)
            </div>
            <canvas id='rankingChart' style={{ maxHeight: '340px' }} />
          </div>
        </section>

        <section className='tables'>
          <div className='card'>
            <div className='section-head'>
              <div className='section-title'>Chamados abertos</div>
              <button className='btn secondary small' id='viewAllTicketsBtn'>
                Ver todos
              </button>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Chamado</th>
                  <th>Estação</th>
                  <th>Status</th>
                  <th>Severidade</th>
                </tr>
              </thead>
              <tbody id='openTicketsTable' />
            </table>
          </div>
          <div className='card'>
            <div className='section-head'>
              <div className='section-title'>Últimas manutenções</div>
              <button
                className='btn secondary small'
                id='viewAllMaintenancesBtn'
              >
                Ver todas
              </button>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Estação</th>
                  <th>Tipo</th>
                  <th>Motivo</th>
                </tr>
              </thead>
              <tbody id='maintenanceTable' />
            </table>
          </div>
        </section>
      </main>

      <div className='modal-overlay' id='partnersModal'>
        <div className='records-modal'>
          <div className='modal-header'>
            <div>
              <h2>Parceiros</h2>
              <p>
                Cadastro e consulta de parceiros locais para atendimento em
                campo.
              </p>
            </div>
            <button
              className='close-btn'
              id='closePartnersModalBtn'
              aria-label='Fechar'
            >
              ×
            </button>
          </div>

          <div className='modal-body'>
            <div className='partners-actions'>
              <div style={{ minWidth: 280, flex: 1 }}>
                <label>Buscar parceiro</label>
                <input
                  id='partnersSearch'
                  placeholder='Nome, CNPJ, cidade, responsável...'
                />
              </div>

              <div style={{ display: 'flex', gap: 12, alignItems: 'end' }}>
                <button
                  className='btn secondary'
                  id='refreshPartnersBtn'
                  type='button'
                >
                  Atualizar
                </button>
                <button className='btn' id='togglePartnerFormBtn' type='button'>
                  + Novo parceiro
                </button>
              </div>
            </div>

            <div className='partners-list-wrap'>
              <table className='partners-table'>
                <thead>
                  <tr>
                    <th>Nome Parceiro</th>
                    <th>CNPJ</th>
                    <th>Responsável</th>
                    <th>Telefone</th>
                    <th>Email</th>
                    <th>Cidade</th>
                    <th>NR10</th>
                    <th>Observações</th>
                  </tr>
                </thead>
                <tbody id='partnersTableBody' />
              </table>
            </div>

            <form className='partner-form' id='partnerForm'>
              <h3 style={{ margin: '0 0 16px', fontSize: 22 }}>
                Cadastrar novo parceiro
              </h3>

              <div className='form-grid'>
                <div>
                  <label>Nome Parceiro</label>
                  <input
                    id='partnerName'
                    required
                    placeholder='Ex.: Elétrica Campos Novos'
                  />
                </div>

                <div>
                  <label>CNPJ</label>
                  <input id='partnerCnpj' placeholder='00.000.000/0000-00' />
                </div>

                <div>
                  <label>Responsável</label>
                  <input
                    id='partnerResponsible'
                    placeholder='Nome do responsável'
                  />
                </div>

                <div>
                  <label>Telefone</label>
                  <input id='partnerPhone' placeholder='(00) 00000-0000' />
                </div>

                <div>
                  <label>Email</label>
                  <input
                    id='partnerEmail'
                    type='email'
                    placeholder='email@empresa.com'
                  />
                </div>

                <div>
                  <label>Cidade</label>
                  <input id='partnerCity' placeholder='Cidade de atuação' />
                </div>

                <div>
                  <label>NR10</label>
                  <select id='partnerNr10'>
                    <option value=''>Não informado</option>
                    <option value='true'>Sim</option>
                    <option value='false'>Não</option>
                  </select>
                </div>

                <div className='full'>
                  <label>Observações</label>
                  <textarea
                    id='partnerNotes'
                    placeholder='Documentações, região de atendimento, restrições, histórico...'
                  />
                </div>
              </div>

              <div id='partnerMessage' className='message' />

              <div className='modal-actions'>
                <button
                  className='btn secondary'
                  id='cancelPartnerFormBtn'
                  type='button'
                >
                  Cancelar
                </button>
                <button className='btn' id='savePartnerBtn' type='submit'>
                  Salvar parceiro
                </button>
              </div>
            </form>

            <div className='modal-actions'>
              <button className='btn secondary' id='closePartnersFooterBtn'>
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='modal-overlay' id='recordsModal'>
        <div className='records-modal'>
          <div className='modal-header'>
            <div>
              <h2 id='recordsModalTitle'>Registros</h2>
              <p id='recordsModalSubtitle'>
                Consulte, filtre e exporte os registros.
              </p>
            </div>
            <button
              className='close-btn'
              id='closeRecordsModalBtn'
              aria-label='Fechar'
            >
              ×
            </button>
          </div>

          <div className='modal-body'>
            <div className='records-toolbar'>
              <div>
                <label>Buscar</label>
                <input
                  id='recordsSearch'
                  placeholder='Buscar nos registros...'
                />
              </div>

              <div>
                <label>Estação</label>
                <select id='recordsStationFilter' />
              </div>

              <div>
                <label>Status / Tipo</label>
                <select id='recordsStatusFilter' />
              </div>

              <div>
                <label>Severidade</label>
                <select id='recordsSeverityFilter' />
              </div>

              <div>
                <label>Contrato</label>
                <select id='recordsContratoFilter'>
                  <option value='Todos'>Todos</option>
                  <option value='P&D'>P&amp;D</option>
                  <option value='Novos Negócios'>Novos Negócios</option>
                </select>
              </div>

              <div>
                <label>De</label>
                <input id='recordsDateFromFilter' type='date' />
              </div>

              <div>
                <label>Até</label>
                <input id='recordsDateToFilter' type='date' />
              </div>

              <div>
                <button className='btn small' id='downloadPdfBtn'>
                  Baixar PDF
                </button>
              </div>
            </div>

            <div className='records-table-wrap'>
              <table className='records-table'>
                <thead id='recordsTableHead' />
                <tbody id='recordsTableBody' />
              </table>
            </div>

            <div className='modal-actions'>
              <button className='btn secondary' id='closeRecordsFooterBtn'>
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='modal-overlay' id='maintenanceModal'>
        <div className='modal'>
          <div className='modal-header'>
            <div>
              <h2>Registrar manutenção</h2>
              <p>
                Registre uma manutenção preventiva ou corretiva vinculada a uma
                estação.
              </p>
            </div>
            <button
              className='close-btn'
              id='closeMaintenanceModalBtn'
              aria-label='Fechar'
            >
              ×
            </button>
          </div>

          <form className='modal-body' id='maintenanceForm'>
            <div className='form-grid'>
              <div>
                <label>Data</label>
                <input id='maintenanceDate' type='date' required />
              </div>

              <div>
                <label>Horário</label>
                <input id='maintenanceTime' type='time' />
              </div>

              <div className='full'>
                <label>Estação / Carregador</label>
                <select id='maintenanceStation' required />
              </div>

              <div className='full'>
                <label>Chamado relacionado</label>
                <select id='maintenanceTicket'>
                  <option value=''>Sem chamado vinculado</option>
                </select>
              </div>

              <div>
                <label>Tipo de manutenção</label>
                <select id='maintenanceType' required>
                  <option value=''>Selecione</option>
                  <option value='Preventiva'>Preventiva</option>
                  <option value='Corretiva'>Corretiva</option>
                </select>
              </div>

              <div>
                <label>Categoria de Falha</label>
                <select id='maintenanceCategory'>
                  <option value=''>Selecione</option>
                  <option value='Problema com Disjuntor'>
                    Problema com Disjuntor
                  </option>
                  <option value='Problema de comunicação'>
                    Problema de comunicação
                  </option>
                  <option value='Firmware'>Firmware</option>
                  <option value='Conector'>Conector</option>
                  <option value='Internet'>Internet</option>
                  <option value='Preventiva'>Preventiva</option>
                  <option value='Botão de Emergência'>
                    Botão de Emergência
                  </option>
                  <option value='Mudança de local'>Mudança de local</option>
                  <option value='Desarme de DR'>Desarme de DR</option>
                  <option value='Problema com o Carregador'>
                    Problema com o Carregador
                  </option>
                </select>
              </div>

              <div>
                <label>Severidade</label>
                <select id='maintenanceSeverity'>
                  <option value=''>Selecione</option>
                  <option value='Baixa'>Baixa</option>
                  <option value='Média'>Média</option>
                  <option value='Alta'>Alta</option>
                  <option value='Crítica'>Crítica</option>
                </select>
              </div>

              <div>
                <label>Status</label>
                <select id='maintenanceStatus'>
                  <option value=''>Sem status</option>
                  <option value='Aberto'>Aberto</option>
                  <option value='Em atendimento'>Em atendimento</option>
                  <option value='Parceiro acionado'>Parceiro acionado</option>
                  <option value='Resolvido'>Resolvido</option>
                  <option value='Cancelado'>Cancelado</option>
                </select>
              </div>

              <div className='full'>
                <label>Motivo / causa</label>
                <textarea
                  id='maintenanceReason'
                  placeholder='Ex.: disjuntor desarmando, display queimado, troca de fusível...'
                  required
                />
              </div>

              <div className='full'>
                <label>O que foi feito</label>
                <textarea
                  id='maintenanceAction'
                  placeholder='Descreva a ação executada...'
                />
              </div>

              <div>
                <label>Solicitante</label>
                <input
                  id='maintenanceRequester'
                  placeholder='Ex.: CELESC, usuário, operador local...'
                />
              </div>

              <div>
                <label>Responsável</label>
                <input
                  id='maintenanceResponsible'
                  placeholder='Responsável técnico / interno'
                />
              </div>

              <div>
                <label>Tempo total</label>
                <input
                  id='maintenanceTotalTime'
                  placeholder='Ex.: 2h, 40min, 1:30 ou 70'
                />
              </div>

              <div>
                <label>Recorrência</label>
                <select id='maintenanceRecurrence'>
                  <option value=''>Não informado</option>
                  <option value='Sim'>Sim</option>
                  <option value='Não'>Não</option>
                </select>
              </div>

              <div>
                <label>Custo (R$)</label>
                <input
                  id='maintenanceCusto'
                  type='number'
                  step='0.01'
                  min='0'
                  placeholder='Preenchido automaticamente...'
                />
                <p className='muted' style={{ margin: '6px 0 0', fontSize: 13 }}>
                  P&amp;D = R$500 · NN AC = R$1.000 · NN DC = R$1.500. Edite se
                  necessário.
                </p>
              </div>

              <div className='full'>
                <label>Fotos / evidências</label>
                <input
                  id='maintenanceFiles'
                  type='file'
                  multiple
                  accept='image/*,video/*,.pdf'
                />
                <p
                  className='muted'
                  style={{ margin: '8px 0 0', fontSize: 13 }}
                >
                  As evidências serão enviadas ao Cloudinary e anexadas no
                  Airtable como URL pública.
                </p>
              </div>
            </div>

            <div id='maintenanceMessage' className='message' />

            <div className='modal-actions'>
              <button
                type='button'
                className='btn secondary'
                id='cancelMaintenanceBtn'
              >
                Cancelar
              </button>
              <button type='submit' className='btn' id='saveMaintenanceBtn'>
                Salvar manutenção
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className='modal-overlay' id='ticketModal'>
        <div className='modal'>
          <div className='modal-header'>
            <div>
              <h2>Abrir chamado</h2>
              <p>
                Registre uma ocorrência operacional para acompanhamento da
                equipe.
              </p>
            </div>
            <button
              className='close-btn'
              id='closeTicketModalBtn'
              aria-label='Fechar'
            >
              x
            </button>
          </div>
          <form className='modal-body' id='ticketForm' noValidate>
            <div className='form-grid'>
              <div className='full'>
                <label>Estação</label>
                <select id='ticketStation' required />
              </div>
              <div>
                <label>Severidade</label>
                <select id='ticketSeverity'>
                  <option value=''>Selecione</option>
                  <option value='Baixa'>Baixa</option>
                  <option value='Média'>Média</option>
                  <option value='Alta'>Alta</option>
                  <option value='Crítica'>Crítica</option>
                </select>
              </div>
              <div>
                <label>Origem</label>
                <select id='ticketOrigin'>
                  <option value=''>Selecione</option>
                  <option value='Operação Move'>Operação Move</option>
                  <option value='WhatsApp'>WhatsApp</option>
                  <option value='Operador Local'>Operador Local</option>
                  <option value='Usuário App'>Usuário App</option>
                  <option value='Monitoramento OCPP'>Monitoramento OCPP</option>
                  <option value='CELESC'>CELESC</option>
                  <option value='Telefone'>Telefone</option>
                  <option value='E-mail'>E-mail</option>
                </select>
              </div>
              <div className='full'>
                <label>Problema relatado</label>
                <textarea
                  id='ticketProblem'
                  placeholder='Descreva o problema relatado...'
                  required
                />
              </div>
              <div>
                <label>Solicitante</label>
                <input id='ticketRequester' placeholder='Nome do solicitante' />
              </div>
              <div>
                <label>Telefone do solicitante</label>
                <input id='ticketPhone' placeholder='(00) 00000-0000' />
              </div>
              <div className='full'>
                <label>Fotos / evidências</label>
                <input
                  id='ticketFiles'
                  type='file'
                  multiple
                  accept='image/*,video/*,.pdf'
                />
                <p
                  className='muted'
                  style={{ margin: '8px 0 0', fontSize: 13 }}
                >
                  As evidências serão enviadas ao Cloudinary e anexadas no
                  Airtable como URL pública.
                </p>
              </div>
            </div>
            <div id='ticketMessage' className='message' />
            <div className='modal-actions'>
              <button
                type='button'
                className='btn secondary'
                id='cancelTicketBtn'
              >
                Cancelar
              </button>
              <button type='submit' className='btn' id='saveTicketBtn'>
                Salvar chamado
              </button>
            </div>
          </form>
        </div>
      </div>
    </S.Root>
  );
};

export default MaintenanceList;
